export function nicedate (value) {
    const requestedDate = new Date(value);
    const now = new Date();
    now.setMinutes(now.getMinutes() - 1);
    if (requestedDate > now) {
        return 'moments ago'
    }
    
    now.setMinutes(now.getMinutes() - 5);
    if (requestedDate > now) {
        return 'a few minutes ago'
    }
    
    now.setMinutes(now.getMinutes() - 25);
    if (requestedDate > now) {
        return ((new Date().getTime() - requestedDate.getTime()) / 1000 / 60).toFixed(0) + ' minutes ago'
    }
    
    now.setMinutes(now.getMinutes() - 29);
    if (requestedDate > now) {
        return 'less than an hour ago'
    }
    
    now.setMinutes(now.getMinutes() - 20);
    if (requestedDate > now) {
        return 'an hour ago'
    }
    
    now.setMinutes(now.getMinutes() - 40);
    if (requestedDate > now) {
        return requestedDate.toLocaleTimeString()
    }
    
    now.setHours(now.getHours() - 22);
    if (requestedDate > now) {
        if (now.getDay() == requestedDate.getDay()) {
            return requestedDate.toLocaleTimeString()
        } else {
            return ((new Date().getTime() - requestedDate.getTime()) / 1000 / 60 / 60).toFixed(0) + ' hours ago'
        }
    }
    
    now.setHours(now.getHours() - (6 * 24));
    if (requestedDate > now) {
        let weekday = 'a few days ago'
        switch(requestedDate.getDay()) {
            case 0: weekday = "Sunday"; break;
            case 1: weekday = "Monday"; break;
            case 2: weekday = "Tuesday"; break;
            case 3: weekday = "Wednesday"; break;
            case 4: weekday = "Thursday"; break;
            case 5: weekday = "Friday"; break;
            case 6: weekday = "Saturday"; break;
        }
        return weekday;
    }
    
    return requestedDate.toLocaleDateString()
}